import { render, staticRenderFns } from "./MainTableLayout.vue?vue&type=template&id=4e22f040&"
import script from "./MainTableLayout.vue?vue&type=script&lang=js&"
export * from "./MainTableLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports